import { render, staticRenderFns } from "./ProfileSlots.vue?vue&type=template&id=449a9990&scoped=true&"
import script from "./ProfileSlots.vue?vue&type=script&lang=js&"
export * from "./ProfileSlots.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSlots.vue?vue&type=style&index=0&id=449a9990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a9990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
